import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material'
import Typography from '../../typography/typography'
import { Close } from '@mui/icons-material'
import Button from '../../button/button'
import { useMemo, useRef, useState } from 'react';
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReportButtons from '../report-buttons/report-buttons';
import { useAppSelector } from '../../../redux/hooks';
import './reportFilter.scss'
export const ReportFilter = ({ openFilter, closeReportFilter, filters, showAssembluItemsFilter, toggleCallback, onDateFilterChange, showBomFilter }) => {
    //Ref
    const chipDateSelectRef = useRef<HTMLDivElement>(null);
    const anchorRef = useRef<HTMLDivElement | null>(null);
    //Local State
    const [open, setOpen] = useState<boolean>(false);

    //store
    const { companies, items, warehouseLocations, assemblyItems, bomData } = useAppSelector(
        (store) => store.inventoryReportsTitleBar
    );

    //Function
    const handleCloseDatePopper = () => {
        anchorRef.current = null;
        setOpen(false);
    };

    //use Memo

    const selectedCompany = useMemo(
        () =>
            companies?.find((company) => filters?.company === company.id)
                ?.company_name || "Select company",
        [companies, filters?.company]
    );

    const companyOptions = useMemo(
        () =>
            companies?.map((company) => ({
                label: company?.company_name || "",
                callback: () => onDateFilterChange?.({ company: company?.id }),
            })) || [],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [companies]
    );
    const selectedItem = useMemo(
        () =>
            items?.find((item) => filters?.item_id === item.id)?.name ||
            "Select item",
        [items, filters?.item_id]
    );
    const selectedAssemblyItems = useMemo(() => assemblyItems?.find((item) => filters?.assembly_item_id === item.id)?.name ||
        "Select Assembly Item",
        [assemblyItems, filters?.assembly_item_id])

    const assemblyItemOptions = useMemo(
        () =>
            assemblyItems?.map((ai) => ({
                label: ai?.name || "",
                callback: () =>
                    onDateFilterChange?.({ assembly_item_id: ai?.id }),
            })) || [],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [assemblyItems]
    );
    const selectedWarehouseLocation = useMemo(
        () =>
            warehouseLocations?.find(
                (warehouseLocation) => filters?.warehouse_id === warehouseLocation.id
            )?.name || "Select warehouse",
        [warehouseLocations, filters?.warehouse_id]
    );
    const warehouseLocationOptions = useMemo(
        () =>
            warehouseLocations?.map((warehouseLocation) => ({
                label: warehouseLocation?.name || "",
                callback: () =>
                    onDateFilterChange?.({ warehouse_id: warehouseLocation?.id }),
            })) || [],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [warehouseLocations]
    );
    const selectedBom = useMemo(
        () =>
            bomData?.find((item) => filters?.bom_id === item.id)?.name ||
            "Select BoM",
        [bomData, filters?.bom_id]
    );
    const bomOptions = useMemo(() => bomData?.map((bom: any) => ({
        label: bom?.name || "",
        callback: () =>
            onDateFilterChange?.({ bom_id: bom?.id }),
    })) || [],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [bomData])

    const itemOptions = useMemo(
        () =>
            items?.map((item) => ({
                label: item?.name || "",
                callback: () => onDateFilterChange?.({ item_id: item?.id }),
            })) || [],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [items]
    );
    return (
        <>
            <Dialog
                open={openFilter}
                onClose={closeReportFilter}
                aria-labelledby="alert-dialog-title"
                fullWidth={true}
                maxWidth="lg"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: { width: '80vw', height: '250px', whiteSpace: 'nowrap', overflowY: 'hidden' } // Custom width and height with nowrap
                }}
            >
                <DialogTitle id="responsive-dialog-title" style={{ borderBottom: "1px solid #D3D3D4", padding: 0, paddingTop: '5pxs' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            height: '40px',
                            padding: '0px',
                            alignItems: 'center'
                        }}
                    >
                        <Typography type="s3" weight='medium' sx={{ fontWeight: 500, marginLeft: 2, color: '#000000' }}>
                            Filter
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>

                            <IconButton onClick={closeReportFilter}>
                                <Close fontSize='small' />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box p={2}>
                        <div className="inventoryReportsTitleBar--FilterWrapper">

                            {filters?.start_date && filters?.end_date && (
                                <div style={{ display: "flex", gap: "8px" }}>
                                    <div
                                        className="inventoryReportsTitleBar--FilterWrapper--Chip"
                                        ref={chipDateSelectRef}
                                        onClick={() => {
                                            if (!open) {
                                                anchorRef.current = chipDateSelectRef.current;
                                                setOpen(true);
                                            } else {
                                                handleCloseDatePopper();
                                            }
                                        }}
                                    >
                                        <div
                                            className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                                            title={`${dayjs(filters?.start_date).format("DD/MM/YYYY")} - ${dayjs(filters?.end_date).format("DD/MM/YYYY")}`}
                                        >
                                            <Typography type="s4" weight="medium">
                                                Date Range:
                                            </Typography>
                                            <Typography
                                                className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                                                type="s4"
                                            >
                                                {dayjs(filters?.start_date).format("DD/MM/YYYY")} -{" "}
                                                {dayjs(filters?.end_date).format("DD/MM/YYYY")}
                                            </Typography>
                                        </div>
                                        <KeyboardArrowDownIcon />
                                    </div>
                                </div>
                            )}
                            {filters?.as_of_date && (
                                <div style={{ display: "flex", gap: "8px" }}>
                                    <div
                                        className="inventoryReportsTitleBar--FilterWrapper--Chip"
                                        ref={chipDateSelectRef}
                                        onClick={() => {
                                            if (!open) {
                                                anchorRef.current = chipDateSelectRef.current;
                                                setOpen(true);
                                            } else {
                                                handleCloseDatePopper();
                                            }
                                        }}
                                    >
                                        <div
                                            className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                                            title={`${dayjs(filters?.as_of_date).format("DD/MM/YYYY")}`}
                                        >
                                            <Typography type="s4" weight="medium">
                                                Date:
                                            </Typography>
                                            <Typography
                                                className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                                                type="s4"
                                            >
                                                {dayjs(filters?.as_of_date).format("DD/MM/YYYY")}
                                            </Typography>
                                        </div>
                                        <KeyboardArrowDownIcon />
                                    </div>
                                </div>
                            )}
                            <div style={{ display: "flex", gap: "8px" }}>
                                <ReportButtons
                                    zIndex={998}
                                    className="inventoryReportsTitleBar--RightContent"
                                    dropdownMenuButtonData={{
                                        sx: {
                                            padding: "0",
                                        },
                                        children: (
                                            <>
                                                <div className="inventoryReportsTitleBar--FilterWrapper--Chip">
                                                    <div
                                                        className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                                                        title={`${selectedCompany}`}
                                                    >
                                                        <Typography type="s4" weight="medium">
                                                            Company:
                                                        </Typography>
                                                        <Typography
                                                            className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                                                            type="s4"
                                                        >
                                                            {selectedCompany}
                                                        </Typography>
                                                    </div>
                                                    <KeyboardArrowDownIcon />
                                                </div>
                                            </>
                                        ),
                                        options: companyOptions,
                                    }}
                                    toggleCallback={toggleCallback}
                                />
                            </div>
                            {
                                showAssembluItemsFilter && <div style={{ display: "flex", gap: "8px" }}>
                                    <ReportButtons
                                        zIndex={998}
                                        className="inventoryReportsTitleBar--RightContent"
                                        dropdownMenuButtonData={{
                                            sx: {
                                                padding: "0",
                                            },
                                            children: (
                                                <>
                                                    <div className="inventoryReportsTitleBar--FilterWrapper--Chip">
                                                        <div
                                                            className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                                                            title={`${selectedAssemblyItems}`}
                                                        >
                                                            <Typography type="s4" weight="medium">
                                                                Assembly Items
                                                            </Typography>
                                                            <Typography
                                                                className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                                                                type="s4"
                                                            >
                                                                {selectedAssemblyItems}
                                                            </Typography>
                                                        </div>
                                                        <KeyboardArrowDownIcon />
                                                    </div>
                                                </>
                                            ),
                                            options: assemblyItemOptions,
                                        }}
                                        toggleCallback={toggleCallback}
                                    />
                                </div>
                            }

                            <div style={{ display: "flex", gap: "8px" }}>
                                <ReportButtons
                                    zIndex={998}
                                    className="inventoryReportsTitleBar--RightContent"
                                    dropdownMenuButtonData={{
                                        sx: {
                                            padding: "0",
                                        },
                                        children: (
                                            <>
                                                <div className="inventoryReportsTitleBar--FilterWrapper--Chip">
                                                    <div
                                                        className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                                                        title={`${selectedWarehouseLocation}`}
                                                    >
                                                        <Typography type="s4" weight="medium">
                                                            Location:
                                                        </Typography>
                                                        <Typography
                                                            className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                                                            type="s4"
                                                        >
                                                            {selectedWarehouseLocation}
                                                        </Typography>
                                                    </div>
                                                    <KeyboardArrowDownIcon />
                                                </div>
                                            </>
                                        ),
                                        options: warehouseLocationOptions,
                                    }}
                                    toggleCallback={toggleCallback}
                                />
                            </div>
                            <div style={{ display: "flex", gap: "8px" }}>
                                <ReportButtons
                                    zIndex={998}
                                    className="inventoryReportsTitleBar--RightContent"
                                    dropdownMenuButtonData={{
                                        sx: {
                                            padding: "0",
                                        },
                                        children: (
                                            <>
                                                <div className="inventoryReportsTitleBar--FilterWrapper--Chip">
                                                    <div
                                                        className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                                                        title={`${selectedItem}`}
                                                    >
                                                        <Typography type="s4" weight="medium">
                                                            Item:
                                                        </Typography>
                                                        <Typography
                                                            className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                                                            type="s4"
                                                        >
                                                            {selectedItem}
                                                        </Typography>
                                                    </div>
                                                    <KeyboardArrowDownIcon />
                                                </div>
                                            </>
                                        ),
                                        options: itemOptions,
                                    }}
                                    toggleCallback={toggleCallback}
                                />
                            </div>
                            {showBomFilter && <div style={{ display: "flex", gap: "8px" }}>
                                <ReportButtons
                                    zIndex={998}
                                    className="inventoryReportsTitleBar--RightContent"
                                    dropdownMenuButtonData={{
                                        sx: {
                                            padding: "0",
                                        },
                                        children: (
                                            <>
                                                <div className="inventoryReportsTitleBar--FilterWrapper--Chip">
                                                    <div
                                                        className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                                                        title={`${selectedBom}`}
                                                    >
                                                        <Typography type="s4" weight="medium">
                                                            BoM:
                                                        </Typography>
                                                        <Typography
                                                            className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                                                            type="s4"
                                                        >
                                                            {selectedBom}
                                                        </Typography>
                                                    </div>
                                                    <KeyboardArrowDownIcon />
                                                </div>
                                            </>
                                        ),
                                        options: bomOptions,
                                    }}
                                    toggleCallback={toggleCallback}
                                />
                            </div>}

                        </div>
                    </Box>

                </DialogContent>
                <DialogActions sx={{ backgroundColor: '#F5F6F5' }}>
                    <Button style={{ backgroundColor: '#ffff', color: '#292D32' }} onClick={closeReportFilter} variant='contained' >
                        Close
                    </Button>
                    <Button variant='contained' >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ReportFilter;